import appConfig from 'app-config';
const { env } = appConfig;

const { serviceUrls } = appConfig;

function sanitizeHostName(url) {
    // remove the protocol if it exists
    let tempUrl = `${url}`.replace(/(^\w+:|^)\/\//, '');
    // remove trailing slash
    tempUrl = `${tempUrl}`.replace(/(\/){1,}$/, '');

    return tempUrl;
}

export default class PolicyService {
    
    static getIdCard(policyNumber, termNumber, vehicleNumber, authHeader = {}, sessionUUID = null) {
        const payload = {
            PolicyNumber: policyNumber,
            TermNumber: String(termNumber),
            VehicleNumber: vehicleNumber,
            OS: 'ios'
        };

        const sanitizedApiGateway = sanitizeHostName(env.API_GATEWAY_URL);

        const headers = {
            Authorization: authHeader.Authorization,
            'x-forwarded-host': sanitizedApiGateway,
            'Content-Type': 'application/json',
            Accept: 'application/vnd.apple.pkpass, application/octet-stream'
        };

        if (sessionUUID) {
            headers.sessionUUID = sessionUUID;
        }

        return fetch(serviceUrls.wallet, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        });
    }

    static getJwtToken(policyNumber, termNumber, vehicleNumber, authHeader = {}, sessionUUID = null) {
        const payload = {
            PolicyNumber: policyNumber,
            TermNumber: String(termNumber),
            VehicleNumber: vehicleNumber,
            OS: 'android'
        };

        const sanitizedApiGateway = sanitizeHostName(env.API_GATEWAY_URL);

        const headers = {
            Authorization: authHeader.Authorization,
            'x-forwarded-host': sanitizedApiGateway,
            'Content-Type': 'application/json'
        };

        if (sessionUUID) {
            headers.sessionUUID = sessionUUID;
        }

        return fetch(serviceUrls.wallet, {
            method: 'POST',
            headers,
            body: JSON.stringify(payload)
        });
    }
}